module.exports = __webpack_public_path__ + "img/logo-sign.9e319250.svg";